import { ClockConfig, TemplateBackstageLogoIcon } from '@backstage/plugin-home';
import { makeStyles } from '@material-ui/core/styles';
import AxlLogo from './AXLLogo';
import CompassLogo from './CompassLogo';
import ImportExportIcon from '@material-ui/icons/ImportExport';

export const useLogoStyles = makeStyles(theme => ({
  container: {
    margin: theme.spacing(5, 0),
  },
  svg: {
    width: 'auto',
    height: 100,
  },
  path: {
    fill: theme.palette.text.primary,
  },
}));

export const tools = [
  {
    url: 'https://compass.accessacloud.com',
    label: 'Compass',
    icon: <CompassLogo />,
  },
  {
    url: 'https://evo-docs.access-workspace.com/',
    label: 'Access Evo',
    icon: <TemplateBackstageLogoIcon />,
  },
  {
    url: 'https://ux.accessacloud.com',
    label: 'Experience Language',
    icon: <AxlLogo />,
  },
  {
    url: 'https://tag-v4.docs.access-workspace.com/',
    label: 'Tag Components',
    icon: <TemplateBackstageLogoIcon />,
  },
  {
    url: '/catalog-import',
    label: 'Import Repo',
    icon: <ImportExportIcon />,
  },
];

export const timeFormat: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
};

export const clockConfigs: ClockConfig[] = [
  {
    label: '🇺🇸 NYC',
    timeZone: 'America/New_York',
  },
  {
    label: '🇬🇧 LBH',
    timeZone: 'Europe/London',
  },
  {
    label: '🇷🇴 TIM',
    timeZone: 'Europe/Bucharest',
  },
  {
    label: '🇲🇾 KL',
    timeZone: 'Asia/Kuala_Lumpur',
  },
  {
    label: '🇦🇺 SYD',
    timeZone: 'Australia/Sydney',
  },
];
